<template>
    <div class="form-group" v-bind:class="error ? 'has-error': ''">
        <label>
            {{ trans('Select a category') }}
            <select class="input__field" v-model="categoryId" name="product_category_id">
                <option v-for="category in categories" v-bind:value="category.encoded_id" v-bind:key="category.id">{{ category.title }}</option>
                <option disabled>---</option>
                <option value="NEW">{{ trans('Create new category') }}</option>
            </select>
        </label>
        <div v-if="categoryId && categoryId === 'NEW'" v-bind:class="{'has-error': error}" class="form-group">
            <input v-model="categoryTitle" class="input__field" type="text" ref="product_category_title" name="product_category_title" placeholder="Product category title" maxlength="255">
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            categories: {
                type: Array,
            },
            selected: {
                type: String,
            },
            error: {
                type: String,
                default: null,
            },
        },
        data() {
            return {
                categoryId: this.selected,
                categoryTitle: null,
            }
        },
    }
</script>